<!-- Body -->
<div class="ui basic segment">
    <app-header [title]="title" [back]="true"></app-header>
    <div class="ui layout">
        <div class="content">
            <div class="ui segment">
                <app-task-template-form #taskTemplateForm [taskTemplate]="taskTemplate"></app-task-template-form>
            </div>
            <div class="flex justify-end">
                <ui-button (click)="$event.preventDefault(); cancel()">{{ 'cancel' | appTranslate }} </ui-button>
                <ui-button (click)="save(taskTemplateForm)" type="primary">
                    {{ saveButtonCopy | appTranslate }}
                </ui-button>
            </div>
        </div>

        <div class="sidebar">
            <div class="ui segment">
                <h3 class="text-color">{{ 'employees.tasks-template.tasksTemplates' | appTranslate }}</h3>
                <p>{{ 'employees.tasks-template.tasksCanBeCreatedAdHocOrAsACopyOfATemplate' | appTranslate }}</p>
                <p>{{ 'employees.tasks-template.templatesMakeItEasyToCreateTasks' | appTranslate }}</p>
                <p>
                    <a
                        (click)="
                            analyticService.logLinkOpen(helpCentreArticle, events.PeopleTasksTaskTemplatesEditLearnMore)
                        "
                        target="_blank"
                        >{{ 'employees.tasks-template.learnMore' | appTranslate }}</a
                    >{{ 'employees.tasks-template.aboutTasksAndTemplates' | appTranslate }}
                </p>
            </div>
        </div>
    </div>
</div>
